import { css } from '@emotion/css';

export const main = css`
  position: relative;
  margin: 6px 6px 6px 0;
`
